<template>
    <standard-modal
        name="router-guide"
        :title="title"
        :width="800"
        @hide="step = 1"
    >
        <div>
            <component
                :is="`step-${step}`"
                @next="step++"
                @back="step--"
                @title="setTitle"
                @complete="step = 5"
            />
        </div>
    </standard-modal>
</template>

<script>
    import Step1 from './Step1';
    import Step2 from './Step2';
    import Step3 from './Step3';
    import Step4 from './Step4';
    import Step5 from './Step5';

    export default {
        components: {
            Step1, Step2, Step3, Step4, Step5,
        },
        data() {
            return {
                step: 1,
                title: lang('Routerguiden','Router guide'),
                completed: false,
            };
        },
        methods: {
            setTitle(title) {
                this.title = title;
            },
        },
    };
</script>